function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20875",
    d: "M17.25 10.5A1.25 1.25 0 1 0 16 9.25a1.25 1.25 0 0 0 1.25 1.25z",
    transform: "translate(-11 -6.333)",
    style: {
      fill: "#252529"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20876",
    d: "M13.167 4H4.833A.833.833 0 0 0 4 4.833v8.333a.833.833 0 0 0 .833.834h8.333a.833.833 0 0 0 .834-.833V4.833A.833.833 0 0 0 13.167 4zm0 7.154-1.5-1.5a.833.833 0 0 0-1.175 0l-.663.663L7.5 7.992a.833.833 0 0 0-1.175 0l-1.5 1.5V4.833h8.333z",
    transform: "translate(-4 -4)",
    style: {
      fill: "#252529"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageClicked);
export default __webpack_public_path__ + "static/media/ImageClicked.60021a2a7e77072f0a64e0e7351fb6f5.svg";
export { ForwardRef as ReactComponent };